import deorphanize from "./components/deorphanize";
import swmNavBar from "./components/swmNavBar";
import swmSearch from "./components/swmSearch";
import SimpleScrollbar from 'simple-scrollbar';
import LazyLoad from "vanilla-lazyload";
import './components/modal';
import 'hyphenopoly/Hyphenopoly_Loader';

(function () {
    

    deorphanize("h1, h2, h3, h4, h5, h6, p, a, li", [
        "a",
        "i",
        "o",
        "u",
        "w",
        "z",
        "A",
        "I",
        "O",
        "U",
        "W",
        "Z",

    ]);
    swmNavBar();

    new LazyLoad();

    const searchContainer = document.getElementById("searchContainer");
    SimpleScrollbar.initEl(searchContainer);
    const searchScroll = searchContainer.querySelector(".ss-content");
    const searchInput = document.getElementById("searchInput");
    const searchToggle = document.getElementById("searchToggle");
    const searchPlaceholder = document.getElementById("searchPlaceholder");
    const searchResultsContainer = document.getElementById("searchResultsContainer");
    const searchClose = document.querySelector(".search__close");

    const handleSearchFn = async function (searchPhrase, page) {
        const requestUrl = searchResultsContainer.dataset.valueUrl;
        const formData = new FormData();

        formData.append("action", "search");
        formData.append("method", "search_phrase");
        formData.append("search", searchPhrase);
        formData.append("paged", page + 1);

        try {
            const response = await fetch(requestUrl, {
                method: "POST",
                body: formData,
                credentials: "same-origin",
            });

            if (!response.ok) {
                return false;
            }

            const html = (await response.text()).trim();
            if (!html.length) {
                return false;
            }

            const resultsFragment = document.createElement("template");
            resultsFragment.innerHTML = html;
            searchResultsContainer.appendChild(resultsFragment.content);

            return true;
        } catch (error) {
            console.error("Search request failed", error);
            return false;
        }
    }


    const search = new swmSearch({
        searchContainer: searchContainer,
        searchScroll: searchScroll,
        searchInput: searchInput,
        handleSearchFn: handleSearchFn,
        searchPlaceholder: searchPlaceholder,
        resultsContainer: searchResultsContainer
    });


    searchToggle.addEventListener("click", search.searchToggle);
    searchClose.addEventListener("click", search.searchClose);


    const emptyAnchors = document.querySelectorAll('a[href="#"]');
    for (var i = 0; i < emptyAnchors.length; i++) {
        emptyAnchors[i].onclick = function (e) {
            e.preventDefault();
        }
    }

})()
